var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAF119"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6402 13.8H20.5602C20.8482 13.8 21.0402 13.608 21.0402 13.32V11.88H27.7602V13.32C27.7602 13.608 27.9522 13.8 28.2402 13.8H30.1602C30.4482 13.8 30.6402 13.608 30.6402 13.32V11.88C30.6402 10.296 29.3442 9 27.7602 9H21.0402C19.4562 9 18.1602 10.296 18.1602 11.88V13.32C18.1602 13.608 18.3522 13.8 18.6402 13.8Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 14H11.2C9.44 14 8 15.4727 8 17.2727V34.7273C8 36.5273 9.44 38 11.2 38H36.8C38.56 38 40 36.5273 40 34.7273V17.2727C40 15.4727 38.56 14 36.8 14ZM28.5333 26.0545L22.9333 32.9273C22.6133 33.2545 22.08 32.9818 22.1867 32.5455L23.5733 27.6364H19.8933C19.4667 27.6364 19.1467 27.2 19.3067 26.7636L21.5467 20.8727C21.76 20.3818 22.1867 20.0545 22.72 20.0545H27.1467C27.6267 20.0545 27.9467 20.5455 27.68 20.9818L25.28 24.9091H28.0533C28.5867 24.9091 28.9067 25.6182 28.5333 26.0545Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrep);
export default __webpack_public_path__ + "static/media/prep.716646373b041971eeedc1afce271128.svg";
export { ForwardRef as ReactComponent };